// Utils
import { getThemeConfig } from '../../../provider/reloadedProvider/config';
import { getThemeSelected } from '../../../storybook/utils/stories.common.utils';
const getStepperProgressBarConfig = () => {
    const themeName = getThemeSelected();
    const theme = getThemeConfig(themeName);
    return {
        ctv: {
            bar: {
                background_color: theme.styles.color_comp_progressbar_empty_bg,
            },
            progressBar: {
                background_color: theme.styles.color_comp_progressbar_filled_bg,
            },
        },
    };
};
export { getStepperProgressBarConfig };
//# sourceMappingURL=wizard-stepper.configurations.js.map